export const TRANSACTION_NETWORK_DEF_GET = "/TransactionNetworkDef/GetAllTransactionNetworkDef"